import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IfaRoutingModule } from './ifa-routing.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
//import { LandingPageComponent } from './home/home.component';
import { AdvantagesOfMutualFundsComponent } from './advantages-of-mutual-funds/advantages-of-mutual-funds.component';
import { CategorizationOfMutualFundsComponent } from './categorization-of-mutual-funds/categorization-of-mutual-funds.component';
import { FAQComponent } from './faq/faq.component';
import { IframeCalculatorComponent } from './iframe-calculator/iframe-calculator.component';
import { MutualFundComponent } from './mutual-fund/mutual-fund.component';
import { RisksInMutualFundsComponent } from './risks-in-mutual-funds/risks-in-mutual-funds.component';
import { SIPComponent } from './sip/sip.component';
import { TypesOfMFComponent } from './types-of-mf/types-of-mf.component';
import { WealthCalculatorsComponent } from './wealth-calculators/wealth-calculators.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { MarketViewsComponent } from './market-views/market-views.component';
import { MobileMutualFundComponent } from './mobile-mutual-fund/mobile-mutual-fund.component';
import { ReviewComponent } from './review/review.component';
import { EnvServiceProvider } from './service/env.service.provider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    // LandingPageComponent,
    AdvantagesOfMutualFundsComponent,
    CategorizationOfMutualFundsComponent,
    FAQComponent,
    IframeCalculatorComponent,
    MutualFundComponent,
    RisksInMutualFundsComponent,
    SIPComponent,
    TypesOfMFComponent,
    WealthCalculatorsComponent,
    AboutComponent,
    ContactComponent,
    MarketViewsComponent,
    MobileMutualFundComponent,
    ReviewComponent
  ],
  imports: [CommonModule, IfaRoutingModule, ReactiveFormsModule, FormsModule],
  exports: [FooterComponent, HeaderComponent]
})
export class IfaModule {}
